import { openDB } from "idb";

const DB_NAME    = "EvolveDB";
const DB_VERSION = 2; // Incrementado para agregar peleadores_evento

export async function getDB() {
  return openDB(DB_NAME, DB_VERSION, {
    upgrade(db) {
      if (!db.objectStoreNames.contains("patrocinadores")) {
        db.createObjectStore("patrocinadores");
      }
      if (!db.objectStoreNames.contains("peleadores")) {
        db.createObjectStore("peleadores");
      }
      // Nuevo store para el registro de peleadores en evento
      if (!db.objectStoreNames.contains("peleadores_evento")) {
        db.createObjectStore("peleadores_evento");
      }
    }
  });
}

export async function saveToIndexedDB(storeName, key, value) {
  const db = await getDB();
  return db.put(storeName, value, key);
}

export async function getFromIndexedDB(storeName, key) {
  const db = await getDB();
  return db.get(storeName, key);
}

export async function deleteFromIndexedDB(storeName, key) {
  const db = await getDB();
  return db.delete(storeName, key);
}